import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { FaPlus } from 'react-icons/fa6';
import mock from './mock.js';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { MdOutlineNote } from 'react-icons/md';
import { FaUser } from 'react-icons/fa';
import { RiPulseLine } from 'react-icons/ri';
import { HiOutlineCalendarDays } from 'react-icons/hi2';
import { TbClock } from 'react-icons/tb';
import { RxDoubleArrowUp } from 'react-icons/rx';
import { RxEyeOpen } from 'react-icons/rx';
import { FaCheck } from 'react-icons/fa6';
import { IoIosSearch } from 'react-icons/io';
import { HiPencil } from 'react-icons/hi';
import { PiTrashSimpleBold } from 'react-icons/pi';
import Cookies from 'js-cookie';
import {
	requestSinanNotesList,
	requestOptionsLists,
} from '../../services/sinanRequests.js';

function SinanHub() {
	let navigate = useNavigate();
	// Lista de notificações //
	const [notes, setNotes] = useState([]);

	// Estados dos inputs (valores temporários)
	const [tempUnidade, setTempUnidade] = useState('');
	const [tempNome, setTempNome] = useState('');
	const [tempNumero, setTempNumero] = useState('');
	const [tempDataInicial, setTempDataInicial] = useState('');
	const [tempDataFinal, setTempDataFinal] = useState('');
	const [tempAgravo, setTempAgravo] = useState('');
	const [tempStatus, setTempStatus] = useState('');

	// Estados de filtros aplicados (somente após clicar em "Filtrar")
	const [options, setOptions] = useState({});

	// Paginação
	const [paginaAtual, setPaginaAtual] = useState(1);
	const itensPorPagina = 10;

	const [currentPop, setCurrentPop] = useState('');

	// mapeia o valor selecionado no filtro de status
	// para o código de status esperado pela API (INV, CON, FIN)
	const mapStatusFilter = (value) => {
		if (!value) return '';
		if (value === 'CONCLUIDO') return 'FIN';
		return value; // INV ou CON
	};

	// Aplica os filtros só depois de clicar em "Filtrar"
	/* const notificacoesFiltradas = useMemo(() => {
		return notes?.filter((n) => {
			return (
				(!unidade ||
					n.unidade_nome
						.toLowerCase()
						.includes(unidade.toLowerCase())) &&
				(!nome ||
					n.unidade_nome
						.toLowerCase()
						.includes(nome.toLowerCase())) &&
				(!numero ||
					n.nu_notificacao
						.toLowerCase()
						.includes(numero.toLowerCase())) &&
				(!data || n.dt_notificacao === data) &&
				(!agravo ||
					n.agravo_nome
						.toLowerCase()
						.includes(agravo.toLowerCase())) &&
				(!status || n.status === status)
			);
		});
	}, [unidade, nome, numero, data, agravo, status, notes]); */

	// Paginação calculada

	const totalPaginas = Math.ceil(notes?.length / itensPorPagina);
	const notificacoesPagina = notes?.slice(
		(paginaAtual - 1) * itensPorPagina,
		paginaAtual * itensPorPagina,
	);

	// Função para gerar range de paginação
	const getPaginas = () => {
		if (totalPaginas <= 7)
			return [...Array(totalPaginas)].map((_, i) => i + 1);

		if (paginaAtual <= 4) return [1, 2, 3, 4, 5, '. . .', totalPaginas];
		if (paginaAtual >= totalPaginas - 3)
			return [
				1,
				'. . .',
				totalPaginas - 4,
				totalPaginas - 3,
				totalPaginas - 2,
				totalPaginas - 1,
				totalPaginas,
			];
		return [
			1,
			'. . .',
			paginaAtual - 1,
			paginaAtual,
			paginaAtual + 1,
			'. . .',
			totalPaginas,
		];
	};

	// Quando clicar em "Filtrar"
	const aplicarFiltros = async () => {
		/* setUnidade(tempUnidade);
		setNome(tempNome);
		setNumero(tempNumero);
		setData(tempData);
		setAgravo(tempAgravo);
		setStatus(tempStatus); */
		setPaginaAtual(1); // volta pra primeira página

		// Monta os parâmetros conforme os filtros suportados pela API:
		// nu_notificacao, paciente__no_nome_paciente, agravo__no_agravo,
		// unidade__nome, dt_notificacao__gte, dt_notificacao__lte, status
		const params = Object.fromEntries(
			Object.entries({
				unidade__nome: tempUnidade,
				paciente__no_nome_paciente: tempNome,
				nu_notificacao: tempNumero,
				agravo__no_agravo: tempAgravo,
				status: mapStatusFilter(tempStatus),
				// datas no formato AAAA-MM-DD já são aceitas pela API
				dt_notificacao__gte: tempDataInicial,
				dt_notificacao__lte: tempDataFinal,
			}).filter(([_, v]) => v !== undefined && v !== null && v !== ''),
		);

		let userCookie = Cookies.get('user');
		let token = '';
		if (JSON.parse(userCookie).token) {
			token = JSON.parse(userCookie).token;
		}

		const result = await requestSinanNotesList(params, token);

		if (!result.error) {
			setNotes(result);
		}

		/* console.log(
			tempUnidade,
			tempNome,
			tempNumero,
			tempAgravo,
			tempStatus,
			data
		); */
	};

	useEffect(() => {
		let userCookie = Cookies.get('user');
		let token = '';
		if (JSON.parse(userCookie).token) {
			token = JSON.parse(userCookie).token;
		}

		/* seta a listagem de notificações assim que a pagina é recarregada */

		const handleRequest = async () => {
			//REQUEST DAS OPÇÕES DOS FILTROS//

			const resultOptions = await requestOptionsLists(token);

			if (!resultOptions.error && resultOptions !== undefined) {
				setOptions(resultOptions);
			}

			//REQUEST DOS DOCUMENTOS//

			const result = await requestSinanNotesList({}, token);
			if (!result.error) {
				setNotes(result);
			}
		};
		handleRequest();
	}, []);

	return (
		<div className='flex flex-col gap-2 my-[80px] font-inter min-h-screen'>
			{/* Header */}
			<div className='bg-[#F0F4F8] flex-col py-[32px] w-full h-[182px] flex justify-center text-center gap-[32px]'>
				<p className='text-[#004A80] text-[32px] font-semibold content-center'>
					SINAN
				</p>
				<button
					onClick={() => navigate('/sinan-ficha')}
					className='bg-[#13335A] hover:bg-[#162c47] rounded-[4px]  mx-auto px-[22px] py-[12px] gap-5 flex items-center text-white content-center'>
					<FaPlus className='scale-110' />
					<div className='h-full w-[1.5px] bg-[#001E42]'></div>
					<p>Criar notificação</p>
				</button>
			</div>

			{/* Filtros */}
			<div className='flex w-[90%] sm:w-[95%] items-center mx-auto max-w-[1136px] flex-col justify-center py-2 gap-[24px]'>
				<p className=' text-[22px] font-medium text-[#004A80] '>
					Filtros de busca
				</p>

				<div className='flex lg:flex-row gap-[20px] flex-col max-w-full'>
					<div className='text-[#4F5257] flex gap-[10px] flex-wrap'>
						<div className='flex  w-full gap-[20px]'>
							<div className='flex flex-col max-w-[430px] w-full gap-1'>
								<p>Unidade Notificante</p>
								<select
									className='border border-[#E3E3E3] rounded-md px-2 py-2.5 w-full'
									value={tempUnidade}
									onChange={(e) =>
										setTempUnidade(e.target.value)
									}>
									<option
										hidden
										disabled
										value=''>
										Selecione a unidade
									</option>
									{Array.isArray(options?.unidades) &&
										options?.unidades?.length > 0 &&
										options?.unidades?.map((o, index) => (
											<option
												key={o?.id || index}
												value={o?.nome}>
												{o?.nome}
											</option>
										))}
								</select>
							</div>

							<div className='flex flex-col max-w-[430px] w-full gap-1'>
								<p>Nome do Paciente</p>
								<input
									type='text'
									placeholder='Nome do Paciente'
									className='border border-[#E3E3E3] placeholder:text-[#e7e7e7] rounded-md p-2 w-full'
									value={tempNome}
									onChange={(e) =>
										setTempNome(e.target.value)
									}
								/>
							</div>
							<div className='text-[#4F5257] flex flex-col flex-wrap max-w-full min-w-[230px]'>
								<p>Status</p>
								<label className='gap-2 flex'>
									<input
										type='radio'
										name='status'
										value='INV'
										checked={tempStatus === 'INV'}
										onChange={(e) =>
											setTempStatus(e.target.value)
										}
									/>
									Aguardando investigação
								</label>
								<label className='gap-2 flex'>
									<input
										type='radio'
										name='status'
										value='CON'
										checked={tempStatus === 'CON'}
										onChange={(e) =>
											setTempStatus(e.target.value)
										}
									/>
									Aguardando conclusão
								</label>
								<label className='gap-2 flex'>
									<input
										type='radio'
										name='status'
										value='CONCLUIDO'
										checked={tempStatus === 'CONCLUIDO'}
										onChange={(e) =>
											setTempStatus(e.target.value)
										}
									/>
									Concluído
								</label>
							</div>
						</div>

						<div className='flex flex-col lg:flex-row  justify-between w-full gap-[20px] '>
							<div className='flex flex-col gap-1  w-full lg:w-[2/6]'>
								<p>Número da Notificação</p>
								<input
									type='text'
									placeholder='Número da Notificação'
									className='border border-[#E3E3E3] placeholder:text-[#e7e7e7] rounded-md h-full p-2 w-full min-w-[169px]'
									value={tempNumero}
									onChange={(e) =>
										setTempNumero(e.target.value)
									}
								/>
							</div>

							<div className='flex flex-col gap-1 lg:w-[1/6]'>
								<p>Data Inicial</p>
								<input
									type='date'
									className='border border-[#E3E3E3] placeholder:text-[#e7e7e7] rounded-md h-full p-2 w-full min-w-[169px] '
									value={tempDataInicial}
									onChange={(e) =>
										setTempDataInicial(e.target.value)
									}
								/>
							</div>
							<div className='flex flex-col gap-1  lg:w-[1/6]'>
								<p>Data Final</p>
								<input
									type='date'
									className='border border-[#E3E3E3] placeholder:text-[#e7e7e7] rounded-md h-full p-2 w-full min-w-[169px] '
									value={tempDataFinal}
									onChange={(e) =>
										setTempDataFinal(e.target.value)
									}
								/>
							</div>

							<div className='flex flex-col w-full lg:w-[2/6] h-full '>
								<div className='flex flex-col w-full h-full gap-1 '>
									<p>Agravo</p>
									<select
										className='border border-[#E3E3E3] rounded-md  h-full p-2 w-full'
										value={tempAgravo}
										onChange={(e) =>
											setTempAgravo(e.target.value)
										}>
										<option
											hidden
											disabled
											value=''>
											Selecione o agravo
										</option>

										{Array.isArray(options?.agravos) &&
											options.agravos.length > 0 &&
											options.agravos.map((o, index) => (
												<option
													key={o.id || index}
													value={o.nome}>
													{o.nome}
												</option>
											))}
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className='w-full flex justify-end'>
					<button
						className='border-[1px] text-[#a5a5a5] border-[#E3E3E3] rounded-md p-2 hover:bg-[#004A80] hover:text-white transition-all duration-200 shadow-md w-[170px] mx-auto mt-2'
						onClick={aplicarFiltros}>
						Filtrar
					</button>
				</div>

				<div className='bg-[#E3E3E3] w-full h-[2px]'></div>

				{/* Tabela mobile */}
				<div className=' flex lg:hidden w-full  bg-[#F4F4F4] h-auto py-[12px] px-[10px] rounded-[4px] gap-2 '>
					<div className='rounded-[4px] text-[#416C9F] w-[50px] px-2 flex flex-col  h-auto bg-[#13335A] text-center'>
						<svg
							className='w-[35px] scale-75 h-[95px]'
							xmlns='http://www.w3.org/2000/svg'
							width='21'
							height='21'
							viewBox='0 0 21 21'
							fill='none'>
							<path
								d='M20.5 13.8333H13.8333V20.5H7.16667V13.8333H0.5V7.16667H7.16667V0.5H13.8333V7.16667H20.5'
								fill='#416C9F'
							/>
						</svg>

						<div>
							<MdOutlineNote className='w-[35px] -scale-x-100 rotate-90 h-[95px]' />
						</div>
						<div>
							<FaUser className='w-[35px] scale-75 h-[95px]' />
						</div>
						<div>
							<RiPulseLine className='w-[33px] h-[95px]' />
						</div>
						<div>
							<HiOutlineCalendarDays className='w-[35px] h-[95px]' />
						</div>
						<div>
							<TbClock className='w-[35px] h-[95px]' />
						</div>
					</div>
					<div className='flex w-full overflow-x-scroll text-[#4F5257]'>
						{notificacoesPagina.length === 0 ? (
							<div className='font-semibold text-[#b3b3b3] text-2xl h-[300px] my-auto mx-auto items-center content-center '>
								Nenhuma notificação encontrada
							</div>
						) : (
							notificacoesPagina.map((n, index) => (
								<div
									key={n.id_notificacao + index}
									className={`flex flex-col min-w-[150px]  h-[680px] items-center text-[16px] text-center rounded-md border-[#E3E3E3] ${
										index % 2 !== 0
											? 'bg-white'
											: 'bg-white'
									}`}>
									<p className='w-full h-[95px] px-6 items-center align-middle content-center'>
										{n.unidade_nome}
									</p>
									<div className='h-[2px] mx-auto w-[40%] bg-[#E3E3E3]'></div>
									<p className='w-full h-[95px] px-6 items-center align-middle content-center'>
										{n.nu_notificacao}
									</p>
									<div className='h-[2px] mx-auto w-[40%] bg-[#E3E3E3]'></div>
									<p className='w-full h-[95px] px-6 items-center align-middle content-center'>
										{n.paciente_nome}
									</p>
									<div className='h-[2px] mx-auto w-[40%] bg-[#E3E3E3]'></div>
									<p className='w-full h-[95px] px-6 items-center align-middle content-center'>
										{n.agravo_nome}
									</p>
									<div className='h-[2px] mx-auto w-[40%] bg-[#E3E3E3]'></div>
									<p className='w-full h-[95px] px-6 items-center align-middle content-center'>
										{n.dt_notificacao}
									</p>
									<div className='h-[2px] mx-auto w-[40%] bg-[#E3E3E3]'></div>
									<p
										className={`w-full h-[95px] ${
											n.status === 'Aguardando conclusão'
												? 'text-[#2A688F]'
												: n.status ===
													  'Aguardando investigação'
													? 'text-[#42B9EB]'
													: 'text-[#32993E]'
										} px-6 items-center align-middle content-center`}>
										{n.status}
									</p>
									<div className='relative w-[110px] flex justify-center border-r-[1px] border-[#e6e6e6]'>
										<button
											onClick={() =>
												setCurrentPop(
													currentPop === index
														? ''
														: index,
												)
											}
											className='flex w-[85%] mx-auto hover:bg-[#f7f7f7] text-[#4F5257]  transition-all duration-300 p-2  items-center gap-1 text-[12px] rounded-md bg-white '>
											<RxDoubleArrowUp
												className={`w-[25px] mx-auto h-auto ${
													currentPop === index
														? ''
														: 'scale-y-[-1]'
												}`}
											/>
										</button>

										<div
											className={`${
												currentPop === index
													? 'block'
													: 'hidden'
											} 
            absolute bottom-12 ml-24 z-[30] rounded-md
            bg-white shadow-md border border-gray-200
            py-3 text-start font-inter flex flex-col gap-[16px]
            w-auto h-auto min-w-max`}>
											<button
												className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<RxEyeOpen className='w-[20px] h-[20px]' />
												<p className='font-medium'>
													Visualizar
												</p>
											</button>

											<button className='h-[1px] bg-gray-100 px-3 w-[88%] mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<FaCheck className='w-[20px] h-[20px]' />
												<p className='font-medium'>
													Concluir
												</p>
											</button>

											<button className='h-[1px] bg-gray-100 px-3 w-[88%] mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<IoIosSearch className='w-[20px] h-[20px]' />
												<p className='font-medium'>
													Investigar
												</p>
											</button>

											<button className='h-[1px] bg-gray-100 px-3 w-[88%] mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<HiPencil className='w-[20px] h-[20px]' />
												<p className='font-medium'>
													Reabrir notificação
												</p>
											</button>

											<button className='h-[1px] bg-gray-100 px-3 w-[88%] mx-auto'></button>

											<button className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'>
												<PiTrashSimpleBold className='w-[20px] h-[20px]' />
												<p className='font-medium'>
													Descartar
												</p>
											</button>
										</div>
									</div>
								</div>
							))
						)}
					</div>
				</div>
				{/* Paginação */}
				<div className='lg:hidden w-full flex justify-end items-center  gap-1'>
					<button
						disabled={paginaAtual === 1}
						className='text-[#4F5257] flex items-center gap-2 rounded-md p-2 transition-all duration-200 mx-1 disabled:opacity-50'
						onClick={() =>
							setPaginaAtual((p) => Math.max(p - 1, 1))
						}>
						<FaArrowLeft />
						Anterior
					</button>
					{getPaginas().map((num, i) =>
						num === '. . .' ? (
							<span
								key={i}
								className='px-2 text-[#4F5257]'>
								...
							</span>
						) : (
							<button
								key={i}
								onClick={() => setPaginaAtual(num)}
								className={`mx-1 w-[34px] h-[32px]  rounded-md ${
									num === paginaAtual
										? 'bg-[#004A80] text-white hover:bg-[#204158]'
										: 'text-[#4F5257] hover:bg-[#f0f0f0]'
								}`}>
								{num}
							</button>
						),
					)}
					<button
						disabled={paginaAtual === totalPaginas}
						className='text-[#4F5257] flex items-center rounded-md p-2 transition-all duration-200 mx-1 gap-2 disabled:opacity-50'
						onClick={() =>
							setPaginaAtual((p) => Math.min(p + 1, totalPaginas))
						}>
						Próxima
						<FaArrowRight />
					</button>
				</div>

				{/* Tabela */}
				<div className='hidden lg:block w-full  bg-[#F4F4F4] h-auto py-[12px] px-[10px] rounded-[4px] '>
					<div className='rounded-[4px] py-[14px] px-2 justify-between flex h-auto bg-[#13335A] w-full text-[#FFFFFF] text-center'>
						<p className='w-[110px]'>Ação</p>
						<p className='w-[180px]'>Unidade Notificante</p>
						<p className='w-[110px]'>Notificação</p>
						<p className='w-[160px]'>Nome do paciente</p>
						<p className='w-[180px]'>Agravo</p>
						<p className='w-[100px]'>Data</p>
						<p className='w-[110px]'>Status</p>
					</div>

					<div className='flex-col flex w-full gap-2 text-[#4F5257]'>
						{notificacoesPagina.length === 0 ? (
							<div className='font-semibold text-[#b3b3b3] text-2xl h-[300px] my-auto mx-auto items-center content-center '>
								Nenhuma notificação encontrada
							</div>
						) : (
							notificacoesPagina.map((n, index) => (
								<div
									key={n.id_notificacao + index}
									className={`flex justify-between items-center text-[16px] text-center py-[18px] px-[8px]  rounded-md border-[#E3E3E3] ${
										index % 2 !== 0
											? 'bg-white'
											: 'bg-white'
									}`}>
									<div className='relative w-[110px] flex justify-center border-r-[1px] border-[#e6e6e6]'>
										<button
											onClick={() => {
												setCurrentPop(
													currentPop === index
														? ''
														: index,
												);
											}}
											className='flex w-[85%] mx-auto hover:bg-[#f7f7f7] text-[#4F5257] hover:text-white transition-all duration-300 p-2  items-center gap-1 text-[12px] rounded-md bg-white '>
											<RxDoubleArrowUp
												className={`w-[25px] mx-auto h-auto ${
													currentPop === index
														? ''
														: 'scale-y-[-1]'
												} text-[#13335A]`}
											/>
										</button>

										<div
											className={`${
												currentPop === index
													? 'block'
													: 'hidden'
											} 
                    ${
						index === 7 || index === 8 || index === 9
							? 'bottom-12'
							: 'mt-12'
					}
  absolute  ml-24 
  z-[30] rounded-md
  bg-white shadow-md border border-gray-200
  py-3 text-start font-inter flex flex-col gap-[16px]
  w-auto h-auto min-w-max`}>
											<button
												className='flex px-3 items-center gap-2 transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha', {
														state: {
															tipo: 'Visualizar',
															permissao:
																'Desenvolvedor',
															data: n,
														},
													})
												}>
												<RxEyeOpen className='w-[20px] h-[20px]' />{' '}
												<p className='font-medium'>
													Visualizar
												</p>
											</button>
											<button className='h-[1px] bg-gray-100 px-3 w-[88%] mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2  transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<FaCheck className='w-[20px] h-[20px]' />{' '}
												<p className='font-medium'>
													Concluir
												</p>
											</button>
											<button className='h-[1px] bg-gray-100 px-3 w-[88%]  mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2  transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<IoIosSearch className='w-[20px] h-[20px]' />{' '}
												<p className='font-medium'>
													Investigar
												</p>
											</button>
											<button className='h-[1px] bg-gray-100 px-3 w-[88%]  mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2  transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<HiPencil className='w-[20px] h-[20px]' />{' '}
												<p className='font-medium'>
													Reabrir notificação
												</p>
											</button>
											<button className='h-[1px] bg-gray-100 px-3 w-[88%]  mx-auto'></button>

											<button
												className='flex px-3 items-center gap-2  transition duration-300 hover:text-[#13335A]'
												onClick={() =>
													navigate('/sinan-ficha')
												}>
												<PiTrashSimpleBold className='w-[20px] h-[20px]' />{' '}
												<p className='font-medium'>
													Descartar
												</p>
											</button>
										</div>
									</div>
									<p className='w-[180px]'>
										{n?.unidade_nome}
									</p>
									<div className='h-[45px] w-[1px] bg- bv'></div>
									<p className='w-[110px]'>
										{n?.nu_notificacao}
									</p>
									<div className='h-[45px] w-[1px] bg-[#E3E3E3]'></div>
									<p className='w-[160px]'>
										{n?.paciente_nome}
									</p>
									<div className='h-[45px] w-[1px] bg-[#E3E3E3]'></div>
									<p className='w-[180px]'>
										{n?.agravo_nome}
									</p>
									<div className='h-[45px] w-[1px] bg-[#E3E3E3]'></div>
									<p className='w-[100px]'>
										{n?.dt_notificacao}
									</p>
									<div className='h-[45px] w-[1px] bg-[#E3E3E3]'></div>
									<p
										className={`w-[110px] ${
											n.status === 'Aguardando conclusão'
												? 'text-[#2A688F]'
												: n.status ===
													  'Aguardando investigação'
													? 'text-[#42B9EB]'
													: 'text-[#32993E]'
										}`}>
										{n.status}
									</p>
								</div>
							))
						)}
					</div>
				</div>

				{/* Paginação */}
				<div className='hidden w-full lg:flex justify-end items-center  gap-1'>
					<button
						disabled={paginaAtual === 1}
						className='text-[#4F5257] flex items-center gap-2 rounded-md p-2 transition-all duration-200 mx-1 disabled:opacity-50'
						onClick={() =>
							setPaginaAtual((p) => Math.max(p - 1, 1))
						}>
						<FaArrowLeft />
						Anterior
					</button>
					{getPaginas().map((num, i) =>
						num === '. . .' ? (
							<span
								key={i}
								className='px-2 text-[#4F5257]'>
								...
							</span>
						) : (
							<button
								key={i}
								onClick={() => setPaginaAtual(num)}
								className={`mx-1 w-[34px] h-[32px]  rounded-md ${
									num === paginaAtual
										? 'bg-[#004A80] text-white hover:bg-[#204158]'
										: 'text-[#4F5257] hover:bg-[#f0f0f0]'
								}`}>
								{num}
							</button>
						),
					)}
					<button
						disabled={paginaAtual === totalPaginas}
						className='text-[#4F5257] flex items-center rounded-md p-2 transition-all duration-200 mx-1 gap-2 disabled:opacity-50'
						onClick={() =>
							setPaginaAtual((p) => Math.min(p + 1, totalPaginas))
						}>
						Próxima
						<FaArrowRight />
					</button>
				</div>
			</div>
		</div>
	);
}

export default SinanHub;
